import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutoEntradaService {
  private data = null;
  private url = environment.serviceApi;
  constructor(public http: Http) { }

  getProdutoEntradas() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produtoentrada')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getProdutoEntrada(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produtoentrada/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaProdutoEntrada(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.url + '/produtoentrada', {
        produto_id: data.produto_id,
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        produto_entrada_quantidade: data.produto_entrada_quantidade,
        produto_entrada_data: data.produto_entrada_data,
        produto_entrada_data_gravacao: data.produto_entrada_data_gravacao,
        produto_entrada_nf: data.produto_entrada_nf,
        produto_entrada_valor_unit: data.produto_entrada_valor_unit
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  editaProdutoEntrada(data) {
    return new Promise((resolve, reject) => {
      this.http.put(this.url + '/produtoentrada/' + data.produto_entrada_id, {
        produto_id: data.produto_id,
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        produto_entrada_quantidade: data.produto_entrada_quantidade,
        produto_entrada_data: data.produto_entrada_data,
        produto_entrada_data_gravacao: data.produto_entrada_data_gravacao,
        produto_entrada_nf: data.produto_entrada_nf,
        produto_entrada_valor_unit: data.produto_entrada_valor_unit
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  apagaProdutoEntrada(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/produtoentrada/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
}
